// if (!customElements.get('media-gallery')) {
//   customElements.define('media-gallery', class MediaGallery extends HTMLElement {
//     constructor() {
//       super();
//       this.elements = {
//         liveRegion: this.querySelector('[id^="GalleryStatus"]'),
//         viewer: this.querySelector('[id^="GalleryViewer"]'),
//         thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
//       }
//       this.mql = window.matchMedia('(min-width: 750px)');
//       if (!this.elements.thumbnails) return;

//       this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
//       this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
//         mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
//       });
//       if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
//     }

//     onSlideChanged(event) {
//       const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
//       this.setActiveThumbnail(thumbnail);
//     }

//     setActiveMedia(mediaId, prepend) {
//       const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
//       this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
//         element.classList.remove('is-active');
//       });
//       activeMedia.classList.add('is-active');

//       if (prepend) {
//         activeMedia.parentElement.prepend(activeMedia);
//         if (this.elements.thumbnails) {
//           const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
//           activeThumbnail.parentElement.prepend(activeThumbnail);
//         }
//         if (this.elements.viewer.slider) this.elements.viewer.resetPages();
//       }

//       this.preventStickyHeader();
//       window.setTimeout(() => {
//         if (this.elements.thumbnails) {
//           activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
//         }
//         if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
//           activeMedia.scrollIntoView({behavior: 'smooth'});
//         }
//       });
//       this.playActiveMedia(activeMedia);

//       if (!this.elements.thumbnails) return;
//       const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
//       this.setActiveThumbnail(activeThumbnail);
//       this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
//     }

//     setActiveThumbnail(thumbnail) {
//       if (!this.elements.thumbnails || !thumbnail) return;

//       this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
//       thumbnail.querySelector('button').setAttribute('aria-current', true);
//       if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

//       this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
//     }

//     announceLiveRegion(activeItem, position) {
//       const image = activeItem.querySelector('.product__modal-opener--image img');
//       if (!image) return;
//       image.onload = () => {
//         this.elements.liveRegion.setAttribute('aria-hidden', false);
//         this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
//           '[index]',
//           position
//         );
//         setTimeout(() => {
//           this.elements.liveRegion.setAttribute('aria-hidden', true);
//         }, 2000);
//       };
//       image.src = image.src;
//     }

//     playActiveMedia(activeItem) {
//       window.pauseAllMedia();
//       const deferredMedia = activeItem.querySelector('.deferred-media');
//       if (deferredMedia) deferredMedia.loadContent(false);
//     }

//     preventStickyHeader() {
//       this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
//       if (!this.stickyHeader) return;
//       this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
//     }

//     removeListSemantic() {
//       if (!this.elements.viewer.slider) return;
//       this.elements.viewer.slider.setAttribute('role', 'presentation');
//       this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
//     }
//   });
// }





//inweave@_01 :  code with additional image-changing buttons


if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
      };

      if (!this.elements.viewer || !this.elements.thumbnails) return;

      this.mql = window.matchMedia('(min-width: 750px)');
      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));

      // Attach click listeners for thumbnails
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        const button = mediaToSwitch.querySelector('button');
        if (button) {
          button.addEventListener('click', (e) => {
            e.preventDefault(); // Prevent default button behavior
            this.handleThumbnailClick(mediaToSwitch); // Handle click and media change
          });
        }
      });

      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) {
        this.removeListSemantic();
      }

      this.createMiddleNavButtons();
    }

    handleThumbnailClick(thumbnail) {
      const mediaId = thumbnail?.dataset?.target;
      if (!mediaId) return;

      // Immediately reset the active state and media
      this.setActiveMedia(mediaId, false);

      // Immediately set the active thumbnail
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      if (activeThumbnail) {
        this.setActiveThumbnail(activeThumbnail);
      }
    }

    onSlideChanged(event) {
      const newElement = event?.detail?.currentElement;
      if (!newElement || !newElement.dataset) return;

      const newMediaId = newElement.dataset.mediaId;
      const newThumbnail = this.elements.thumbnails.querySelector(`[data-target="${newMediaId}"]`);
      if (newThumbnail) {
        this.setActiveThumbnail(newThumbnail);
      }
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
      if (!activeMedia) return;

      // Immediately reset all media to ensure one is active
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((media) => {
        media.classList.remove('is-active');
      });

      activeMedia.classList.add('is-active');
      
      // Prepend active media if necessary
      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        if (activeThumbnail) activeThumbnail.parentElement.prepend(activeThumbnail);
      }

      // Force scroll behavior
      this.scrollActiveMediaIntoView(activeMedia);
      this.playActiveMedia(activeMedia);

      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      if (activeThumbnail) {
        this.setActiveThumbnail(activeThumbnail);
      }

      const position = activeThumbnail ? activeThumbnail.dataset.mediaPosition : 'unknown';
      this.announceLiveRegion(activeMedia, position);
    }

    scrollActiveMediaIntoView(activeMedia) {
      // Force scroll into view immediately
      if (this.elements.thumbnails) {
        activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' });
      }
      if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
        activeMedia.scrollIntoView({ behavior: 'smooth' });
      }
    }

    setActiveThumbnail(thumbnail) {
      if (!thumbnail) return;

      // Remove previous active states
      this.elements.thumbnails.querySelectorAll('button').forEach((button) => button.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);

      // Scroll if not visible
      if (!this.elements.thumbnails.isSlideVisible(thumbnail, 10)) {
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft, behavior: 'smooth' });
      }
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;

      this.elements.liveRegion.setAttribute('aria-hidden', false);
      this.elements.liveRegion.textContent = window.accessibilityStrings.imageAvailable.replace('[index]', position);
      setTimeout(() => {
        this.elements.liveRegion.setAttribute('aria-hidden', true);
      }, 2000);
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
    }

    createMiddleNavButtons() {
      const leftButton = document.createElement('button');
      const rightButton = document.createElement('button');

      leftButton.className = 'middle-nav-button left';
      rightButton.className = 'middle-nav-button right';

      // Accessibility labels
      leftButton.setAttribute('aria-label', 'Previous slide');
      rightButton.setAttribute('aria-label', 'Next slide');

      leftButton.innerHTML = `
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.3327 5.33268H3.21935L6.94602 1.60602L5.99935 0.666016L0.666016 5.99935L5.99935 11.3327L6.93935 10.3927L3.21935 6.66602H11.3327V5.33268Z"/>
        </svg>     
      `; // left
      rightButton.innerHTML = `
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.3327 5.33268H3.21935L6.94602 1.60602L5.99935 0.666016L0.666016 5.99935L5.99935 11.3327L6.93935 10.3927L3.21935 6.66602H11.3327V5.33268Z"/>
        </svg> 
      `; // right

      leftButton.addEventListener('click', () => this.navigateMedia('prev'));
      rightButton.addEventListener('click', () => this.navigateMedia('next'));

      this.elements.viewer.appendChild(leftButton);
      this.elements.viewer.appendChild(rightButton);
    }

    navigateMedia(direction) {
      // Use a more specific selector to find actual media items
      const mediaElements = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]:not(.clone)'));
      const currentActive = this.elements.viewer.querySelector('[data-media-id].is-active');
    
      if (!currentActive || mediaElements.length === 0) return;
    
      const currentIndex = mediaElements.indexOf(currentActive);
    
      let newIndex = direction === 'next' 
        ? (currentIndex + 2) % mediaElements.length 
        : (currentIndex - 2 + mediaElements.length) % mediaElements.length;
    
      const newActiveMedia = mediaElements[newIndex];
    
      this.setActiveMedia(newActiveMedia.dataset.mediaId, false);
    }
  });
}


